import script from "./TreasureView.vue?vue&type=script&setup=true&lang=js"
export * from "./TreasureView.vue?vue&type=script&setup=true&lang=js"

import "./TreasureView.vue?vue&type=style&index=0&id=ef4d3600&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef4d3600"]])

export default __exports__